import React, { useMemo, useCallback } from 'react'
import { convertNumberToCapitalLetter } from '../../../utils'
import Option from './Option'

const MAX_ROWS = 4

const OptionsMenu = ({ options = [], extraStyles = {} }) => {
	const optionRows = useMemo(() => {
		if (options.length === 5) {
			return 3
		}
		if (options.length % 3 === 0) {
			return 3
		}
		if (options.length % 4 === 0) {
			return 4
		}
		if (options.length % 5 === 0) {
			return 5
		}

		return MAX_ROWS
	}, [options])

	const columnNumber = useMemo(() => {
		return Math.ceil(options.length / optionRows)
	}, [options, optionRows])

	const createOptions = useCallback(() => {
		// This logic could probably be better.
		const columns = []
		let counter = 0
		for (let x = 0; x < columnNumber; x++) {
			let rows = []
			for (let y = 0; y < optionRows; y++) {
				const option = options[counter]
				if (option) {
					const letter = convertNumberToCapitalLetter(counter)
					rows.push(
						<Option key={`option-${x}-${y}`} letter={letter} {...option} columns={columnNumber} />
					)
				}
				counter++

				if (counter === options.length) {
					break
				}
			}

			columns.push(
				<div key={`column-${x}`} style={{ display: 'flex', flexDirection: 'column', gap: '.6rem' }}>
					{rows}
				</div>
			)
		}
		return columns
	}, [columnNumber, options, optionRows])

	return (
		<div style={{ display: 'flex', flexDirection: 'row', gap: '.6rem', justifyContent: 'center', ...extraStyles }}>
			{createOptions()}
		</div>
	)
}

export default OptionsMenu
